<template>
  <q-card :class="cssClass" class="report-post q-pa-sm">
    <post-media
      class="report-post__media"
      :post-id="post.id"
      :media="post.media"
    />
    <div class="report-post__body">
      <post-time-bar :post="post" />
      <post-toolbar
        :post="post"
        notes-btn-title="Work Product Notes"
        notes
        group
      >
        <trash-btn
          v-show="!reportPost.isTrashed"
          :report-post="reportPost"
          flat
          round
          @trashed="$emit('trashed', $event)"
        />
        <restore-btn
          v-show="reportPost.isTrashed"
          :report-post="reportPost"
          flat
          round
          @restored="$emit('restored', $event)"
        />
      </post-toolbar>
      <post-content :post="post" class="q-pa-md q-ma-none" />
    </div>
    <comments-input
      :report-post="reportPost"
      class="report-post__comments q-mx-md"
      @update:model-value="$emit('update:comment', $event)"
    />
  </q-card>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.report-post {
    display: flex;
    flex-direction: column;
    transition: opacity 0.8s;

    @media screen and (min-width: $breakpoint-md-min) {
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: stretch;

        &__media {
            flex: 0 0 280px;
        }
        &__body {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }

        &__comments {
            flex: 0 0 25%;
            align-self: flex-start;
        }
    }

    &--trashed {
        opacity: 0.5;
    }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReportPost, Post } from '@/type';
import PostMedia from '@/social/post/card/PostMedia.vue';
import PostContent from '@/social/post/card/PostContent.vue';
import PostToolbar from '@/social/post/card/PostToolbar.vue';
import PostTimeBar from '@/social/post/card/PostTimeBar.vue';
import CommentsInput from './CommentsInput.vue';
import TrashBtn from './TrashBtn.vue';
import RestoreBtn from './RestoreBtn.vue';

export default defineComponent({
  emits: ['restored', 'trashed', 'update:comment'],
  components: {
    PostMedia,
    PostContent,
    PostToolbar,
    PostTimeBar,
    CommentsInput,
    TrashBtn,
    RestoreBtn,
  },
  props: {
    reportPost: {
      type: Object as () => ReportPost,
      required: true,
    },
  },
  computed: {
    cssClass(): string {
      return this.reportPost.isTrashed ? 'report-post--trashed' : '';
    },
    post(): Post {
      return this.reportPost.post;
    },
  },
});
</script>
